import React, { Fragment } from 'react';
import { Grid, Card, CardContent, Typography, CardHeader } from '@material-ui/core/';
import { useStyle } from './PrequalStyle.js';

function EirPrequalResult(props) {
    const classes = useStyle();
    return (
        <Fragment>
            <div className={classes.prequalResult}>
                <Grid
                    container
                    spacing={4}
                    direction='row'
                    justify='flex-start'
                    alignItems='center'>
                    {props.data.map(item => (
                        <Grid item xs={12} sm={6} md={6} lg={6} key={props.data.indexOf(item)}>
                            <Card>
                                <CardHeader
                                    title={`EIRCODE : ${item.EIRCODE}`}
                                    subheader={`ARDID : ${item.ARD_ID}`}
                                />
                                <CardContent>
                                    <Typography variant='p' gutterBottom>
                                        BUILDING NO:
                                        {item.BUILDING_NO}
                                    </Typography>
                                </CardContent>
                                <CardContent>
                                    <Typography variant='p' gutterBottom>
                                        COUNTY:
                                        {item.COUNTY}
                                    </Typography>
                                </CardContent>
                                <CardContent>
                                    <Typography variant='p' gutterBottom>
                                        TOWN:
                                        {item.TOWN}
                                    </Typography>
                                </CardContent>
                                <CardContent>
                                    <Typography gutterBottom>
                                        STREET NAME:
                                        {item.ADDRESS}
                                    </Typography>
                                </CardContent>
                                <CardContent>
                                    <Typography variant='p' gutterBottom>
                                        PHONE NUMBER:
                                        {item.PHONE_NUMBER}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </Fragment>
    );
}

export default EirPrequalResult;
